export default function (value) {
  if (!value) return '';

  return value
    .replace(/[^a-zA-Z\d]+/, '')
    .replace(/(?:^|\s|-|\/)\S/g, (x) => x.toUpperCase())
    .replace(/[^a-zA-Z\d]+/g, ' ');
}
